import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {Button, message, Space, Tooltip, Typography} from 'antd';
import _ from 'lodash';

import {CheckOutlined, TeamOutlined, UserOutlined} from '@/icons';
import {PageGrid, RowAction} from '@/component';
import {getColumns} from './userListColumns';

import styles from '../MainPanel.module.less';
import UserViewModal from '@/page/admin/DepartsPage/UserViewModal';

const {Text} = Typography;

export default function UserTabPane({
                                        searchValue,
                                        clearSearchValue,
                                        onAddSelected,
                                        parentUserId,
                                        userType,
                                    }) {
    const tableRef = useRef();
    const viewRef = useRef();

    const [url, setUrl] = useState(null);

    useEffect(() => {
        setUrl(`/reportLine/welcome/list/${parentUserId}`);
    }, [searchValue]);

    function onUserSelect(record) {
        if (userType === 1) {
            const {externalUserId, name} = record.sysCustomer;
            onAddSelected('users', {id: externalUserId, name: name});
        } else {
            onAddSelected('users', {id: record.extId, name: record.name});
        }
    }

    function onUserGroupSelect(record) {
        onAddSelected('groups', {id: record.id, name: record.name});
    }

    function onNameClick(record) {
        return () => {
            viewRef.current.showModal(record);
        };
    }

    const columns = userType === 1 ? getColumns(['cAvatar', 'cName', 'cType']) : getColumns(['avatar', 'name', 'extId'], {onNameClick});

    const columnAction = {
        title: '操作', key: 'selAction', width: 220, // eslint-disable-next-line react/display-name
        // render: (text, record) => <RowAction actions={actions} record={record} />,
        render: (text, record) => {
            let isCheck = false;
            let title = '';
            if (parentUserId && parentUserId == record.id) {
                isCheck = true;
                title = '不能选择用户自己';
            }

            return (<Space>
                    <Tooltip title={title}>
                        <Button
                            disabled={isCheck}
                            icon={<UserOutlined />}
                            onClick={() => onUserSelect(record)}
                        >
                            选择成员
                        </Button>
                    </Tooltip>
                </Space>);
        },
    };
    columns.push(columnAction);

    return (<div className={styles.tabContent2}>
            <div className={styles.tabContentMain}>
                <div className={styles.tabContentInner}>
                    {url && (<PageGrid
                            ref={tableRef}
                            url={url}
                            columns={columns}
                            rowKey="id"
                            paginationProps={{simple: true, showSizeChanger: false}}
                        />)}

                    <UserViewModal ref={viewRef} />
                </div>
            </div>
        </div>);
}

UserTabPane.propTypes = {
    /**
     * 查询条件
     */
    searchValue: PropTypes.string,

    clearSearchValue: PropTypes.func,

    onAddSelected: PropTypes.func.isRequired,
};
